var map = {
	"./account-summary-card-white.svg": "31aa",
	"./account-summary-card.svg": "dd3c",
	"./account-summary-history-white.svg": "4ca9",
	"./account-summary-history.svg": "f18a",
	"./account-summary-pricing-white.svg": "5059b",
	"./account-summary-pricing.svg": "1b3d",
	"./airplane.svg": "5025",
	"./arrow-left-large.svg": "eef3",
	"./arrow-left.svg": "76d5",
	"./arrow-right-large.svg": "1c7a",
	"./asking.svg": "ed68",
	"./asset-explained.svg": "8d3e",
	"./assets-sidebar-icon.svg": "4e06",
	"./bank-assets-blue.svg": "7a9d",
	"./bank-assets.svg": "3508",
	"./basketball.svg": "9b6c",
	"./bell-white.svg": "4439",
	"./bell.svg": "4bf1",
	"./bellx24.svg": "9090",
	"./blank-page.svg": "6eab",
	"./blue-rustic-bg.svg": "4968",
	"./borrow.svg": "ff7a",
	"./budget-calendar.svg": "caf6",
	"./budget-sidebar-icon.svg": "1bad",
	"./budget-view-icon.svg": "0f24",
	"./calendar.svg": "276b",
	"./car.svg": "20c2",
	"./cashapp.svg": "b519",
	"./cat-empty-ahorros-white.svg": "4bb9",
	"./cat-empty-ahorros.svg": "f8fb",
	"./cat-empty-alimentacion.svg": "bf02",
	"./cat-empty-blank-document.svg": "802e",
	"./cat-empty-donaciones.svg": "24ba",
	"./cat-empty-educacion.svg": "6473",
	"./cat-empty-hogar.svg": "307e",
	"./cat-empty-ingresos-white.svg": "8438",
	"./cat-empty-ingresos.svg": "5a42",
	"./cat-empty-ocio.svg": "2cdd",
	"./cat-empty-pagodeuda.svg": "07d2",
	"./cat-empty-personales.svg": "430c",
	"./cat-empty-salud.svg": "5c6a",
	"./cat-empty-servicios.svg": "641f",
	"./cat-empty-transporte.svg": "ae0d",
	"./chevron-right.svg": "906b",
	"./class-icono.svg": "9b23",
	"./close-session.svg": "c7fe",
	"./color-house.svg": "44c8",
	"./config-icon.svg": "8ec7",
	"./credit-card-dark-blue.svg": "23be",
	"./credit-card-gray.svg": "24a6",
	"./credit-card.svg": "982a",
	"./credit-line-icon.svg": "445c",
	"./dashboard-asset.svg": "9944",
	"./dashboard-available.svg": "c1ec",
	"./dashboard-expense.svg": "1789",
	"./dashboard-income-green.svg": "9d89",
	"./dashboard-income.svg": "4c24",
	"./dashboard-liability.svg": "eb00",
	"./dashboard-sidebar-icon.svg": "1b24",
	"./delete-budget.svg": "7981",
	"./denied.svg": "5493",
	"./dollar-symbol-dark-blue.svg": "beca",
	"./dollar-symbol.svg": "e540",
	"./donut-graph.svg": "0a6a",
	"./edit.svg": "582c5",
	"./empty-budget.svg": "6ce4",
	"./empty-state-calendar.svg": "8d83",
	"./etapa-final/Grupo 1639.svg": "31ce",
	"./etapa-final/Icono caja.svg": "cc7f",
	"./etapa-final/Trazado 2282.svg": "4670",
	"./etapa-final/asking.svg": "40cd",
	"./etapa-final/class Icono.svg": "e2b8",
	"./etapa-final/peggy-bank.min.svg": "4465",
	"./etapa-final/piggy-bank.svg": "53c4",
	"./filter-list.svg": "5d39",
	"./financial-health.svg": "cf64",
	"./freelance.svg": "cb73",
	"./goals.svg": "9149",
	"./graduate.svg": "3a48",
	"./graph-up-gray.svg": "388a",
	"./graph-up.svg": "40b1",
	"./green-check.svg": "3deb",
	"./help-sidebar-icon.svg": "d6e5",
	"./house.svg": "68ee",
	"./ibf-empty-state.svg": "3b44",
	"./ibf-explained.svg": "91b2",
	"./ibf.svg": "e52b",
	"./ico-bank.svg": "3ec6",
	"./ico-box.svg": "74a4",
	"./ico-clock.svg": "8552",
	"./icon-book.svg": "b4d2",
	"./icon-calendar.svg": "e509",
	"./icon-estadistica.svg": "4e1d",
	"./icon-headphone.svg": "2ed4",
	"./icon-workspace.svg": "9ac1",
	"./investment.svg": "7955",
	"./left-circle-arrow.svg": "3030",
	"./liability-explained.svg": "74d9",
	"./loan-dark-blue.svg": "bdbe",
	"./loan-gray.svg": "d093",
	"./loan.svg": "80d7",
	"./location-mark.svg": "af4c",
	"./mail-message-icon.svg": "6dec",
	"./menuIcons/calendar.svg": "919e",
	"./menuIcons/foot.svg": "09b7",
	"./menuIcons/graph-up.svg": "da93",
	"./menuIcons/group-line.svg": "9f81",
	"./menuIcons/icon-workspace.svg": "3679",
	"./menuIcons/mortar-board.svg": "e23d",
	"./menuIcons/target.svg": "84d1",
	"./minus-blue.svg": "7749",
	"./minus-green.svg": "52cc",
	"./minus-money.svg": "415b",
	"./minus-red.svg": "45f9",
	"./money-sign-dark-blue.svg": "582c",
	"./money-sign.svg": "2d1e",
	"./my-account.svg": "d8a1",
	"./notification-icon.svg": "3da7",
	"./other-service-blue.svg": "06a1",
	"./other-service.svg": "5e19",
	"./patrimony-explained.svg": "54bc",
	"./pawprint.svg": "5570",
	"./phone-blue.svg": "8532",
	"./phone.svg": "7b69",
	"./piggy-bank.svg": "dfe2",
	"./plan-star.svg": "35db",
	"./plans-icon.svg": "33f8",
	"./repeat.svg": "407e",
	"./right-circle-arrow.svg": "c7c4",
	"./rings.svg": "3f14",
	"./save-money.svg": "9d26",
	"./school-blue.svg": "f27b",
	"./school.svg": "6bfe",
	"./settings-sidebar-icon.svg": "6f3b",
	"./sport-car.svg": "e980",
	"./sunny-day-blue.svg": "eddb",
	"./sunny-day.svg": "42f6",
	"./telephone-icon.svg": "764e",
	"./thunder-2-blue.svg": "28ab",
	"./thunder-2.svg": "7f88",
	"./thunder.svg": "48b3",
	"./toys.svg": "9768",
	"./transaction-chart-empty.svg": "e1a67",
	"./transaction-table.svg": "22f6",
	"./truck-blue.svg": "30cf",
	"./truck.svg": "3fb4",
	"./upcoming-events-empty.svg": "0767",
	"./upcoming-payments-empty.svg": "6c4d",
	"./upcoming-payments.svg": "fd9b",
	"./upload-icon.svg": "157c",
	"./user-icon.svg": "91a6",
	"./wallet-dark-blue.svg": "aa2b",
	"./wallet-gray.svg": "d70c",
	"./wallet.svg": "cd68",
	"./water-blue.svg": "36e7",
	"./water.svg": "445e",
	"./welcome-page.svg": "da42",
	"./white-check.svg": "f726",
	"./x-button.svg": "0710"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57ae";